/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Body1Inputs */

const en_to_xml_body1 = /** @type {(inputs: To_Xml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON and XML describe overlapping but not identical things, so this conversion involves real decisions rather than a mechanical substitution. XML has attributes, namespaces, comments, processing instructions, and mixed content, none of which JSON has. JSON has arrays and a distinction between a number and a string, neither of which XML has. Every JSON to XML converter picks a convention, and knowing which one you are using is the difference between output that works and output that almost works.`)
};

const ko_to_xml_body1 = /** @type {(inputs: To_Xml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON과 XML은 겹치지만 동일하지 않은 것을 서술하므로, 이 변환에는 기계적 치환이 아니라 실제 결정이 개입합니다. XML에는 속성, 네임스페이스, 주석, 처리 명령, 혼합 콘텐츠가 있고 JSON에는 그중 어느 것도 없습니다. JSON에는 배열과 숫자 대 문자열의 구분이 있고 XML에는 둘 다 없습니다. 모든 JSON에서 XML로의 변환기는 하나의 관례를 고르며, 어떤 관례를 쓰는지 아는 것이 잘 동작하는 출력과 거의 동작하는 출력의 차이를 만듭니다.`)
};

const ja_to_xml_body1 = /** @type {(inputs: To_Xml_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON と XML は重なるが同一ではないものを記述するので、この変換には機械的な置換ではなく実際の判断が入ります。XML には属性、名前空間、コメント、処理命令、混在内容があり、JSON にはそのどれもありません。JSON には配列と、数値か文字列かの区別があり、XML にはどちらもありません。あらゆる JSON から XML への変換器は 1 つの慣習を選び、どの慣習を使っているか知っていることが、うまく動く出力とほぼ動く出力の差になります。`)
};

/**
* | output |
* | --- |
* | "JSON and XML describe overlapping but not identical things, so this conversion involves real decisions rather than a mechanical substitution. XML has attribu..." |
*
* @param {To_Xml_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_body1 = /** @type {((inputs?: To_Xml_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_body1(inputs)
	if (locale === "ko") return ko_to_xml_body1(inputs)
	return ja_to_xml_body1(inputs)
});